var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hit-btn-group",attrs:{"data-hit-toggleswitch":""}},[_c('div',{staticClass:"hit-btn",class:_vm.get_class(0),domProps:{"innerHTML":_vm._s(_vm.get_label(0))},on:{"click":_vm.click}}),_c('div',{staticClass:"hit-btn",class:_vm.get_class(1),domProps:{"innerHTML":_vm._s(_vm.get_label(1))},on:{"click":_vm.click}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }